"use strict";

const FactSheetNew = require("../general/factSheetNew");
const ProjectFactSheetController = require("./projectFactSheetController");

const ProjectDeliveryFactSheetController = function () {
  const routeName = "construction-project-delivery-fact-sheet";

  var getConfig = function () {
    return {
      ...ProjectFactSheetController.getConfig(),
      template: "factSheet/construction/constructionProjectDeliveryFactSheet.njk",
      closeUrl: "/ram/projdelivery/construction-project-delivery",
    };
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  return {
    open,
    routeName,
  };
};

module.exports = ProjectDeliveryFactSheetController();
